// extracted by mini-css-extract-plugin
export default {"container":"SensorNotAvailable_container__icAbP","label":"SensorNotAvailable_label__rcj70"};